<p-dialog [(visible)]="showEditTimeDialog" [modal]="true" [style]="{width: '450px'}" 
                [closeOnEscape]="false" [closable]="true" 
                [header]="'Edit ' + (editTimeType === 'pickup' ? 'Pickup' : 'Delivery') + ' Time'">

    
    <div class="field">
      <label class="font-semibold mb-2 block">Date & Time</label>
      <p-calendar
        timeOnly="true"
        [(ngModel)]="selectedDate"
        inputId="calendar-datetime" 
        [showTime]="true" 
        [showSeconds]="false"
        [hourFormat]="'12'"
        [placeholder]="'Select date and time'"
        [appendTo]="'body'"
        dateFormat="mm/dd/yy"
        styleClass="w-full" />
    </div>

  <ng-template pTemplate="footer">
    <div class="flex justify-content-end gap-2">
      <button pButton label="Cancel" icon="pi pi-times" class="p-button-outlined" (click)="showEditTimeDialog = false"></button>
      <button pButton label="Save" icon="pi pi-check" class="p-button-raised" (click)="saveEditTime(editTimeType)"></button>
    </div>
  </ng-template>
</p-dialog>
